var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0594 11.9994L15.3594 9.69937C15.6494 9.40937 15.6494 8.92937 15.3594 8.63938C15.0694 8.34938 14.5894 8.34938 14.2994 8.63938L11.9994 10.9394L9.69937 8.63938C9.40937 8.34938 8.92937 8.34938 8.63938 8.63938C8.34938 8.92937 8.34938 9.40937 8.63938 9.69937L10.9394 11.9994L8.63938 14.2994C8.34938 14.5894 8.34938 15.0694 8.63938 15.3594C8.78938 15.5094 8.97937 15.5794 9.16937 15.5794C9.35937 15.5794 9.54937 15.5094 9.69937 15.3594L11.9994 13.0594L14.2994 15.3594C14.4494 15.5094 14.6394 15.5794 14.8294 15.5794C15.0194 15.5794 15.2094 15.5094 15.3594 15.3594C15.6494 15.0694 15.6494 14.5894 15.3594 14.2994L13.0594 11.9994Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleWhite);
export default __webpack_public_path__ + "static/media/close-circle-white.5467b76ff588c7d82e3d488b470b5604.svg";
export { ForwardRef as ReactComponent };